import Logo from "assets/Logo.png";
import { jsPDF as JsPDF } from "jspdf";

export const downloadInventoryBoxQr = (qrValue: string) => {
  const pdf = new JsPDF({
    unit: "px"
  });

  const qrCanvas = document.getElementById(
    `qr-${qrValue}`
  ) as HTMLCanvasElement;

  const base64Image = qrCanvas.toDataURL();

  const qrWidth = 230;
  const qrHeight = 230;
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  const xQrPos = (pageWidth - qrWidth) / 2;
  const yQrPos = (pageHeight - qrHeight) / 2;

  pdf.addImage(base64Image, "png", xQrPos, yQrPos, qrWidth, qrHeight);
  pdf.addImage(Logo, "png", 20, 20, 60, 13.6);

  pdf.save(`QR-${qrValue}`);
};
